<template>
  <div>
    <v-tabs
      v-model="tab"
      :color="whiteLabel.colors.primary"
      icons-and-text
      show-arrows
      center-active
      fixed-tabs
      align-with-title
    >
      <v-tab key="callTab">
        Llamadas
        <v-icon>mdi-phone-log</v-icon>
      </v-tab>

      <v-tab
        key="accessTab"
        v-if="license.gate && (license.doors > 0 || license.rfid)"
      >
        Accesos
        <v-icon>mdi-door-open</v-icon>
      </v-tab>

      <v-tab key="helpTab">
        S.O.S.
        <v-icon>mdi-lifebuoy</v-icon>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item key="callTab">
        <v-container>
          <CallLogs
            :initial_floor="initial_floor"
            :initial_unit="initial_unit"
          ></CallLogs>
        </v-container>
      </v-tab-item>

      <v-tab-item
        key="accessTab"
        v-if="license.gate && (license.doors > 0 || license.rfid)"
      >
        <v-container>
          <AccessLogs
            :initial_floor="initial_floor"
            :initial_unit="initial_unit"
          ></AccessLogs>
        </v-container>
      </v-tab-item>

      <v-tab-item key="helpTab">
        <v-container>
          <HelpLogs
            :initial_floor="initial_floor"
            :initial_unit="initial_unit"
          ></HelpLogs>
        </v-container>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CallLogs from "@/components/CallLogs";
import AccessLogs from "@/components/AccessLogs";
import HelpLogs from "@/components/HelpLogs";

export default {
  components: {
    CallLogs,
    AccessLogs,
    HelpLogs,
  },
  data: () => ({
    tab: 0,
  }),

  props: ["initial_floor", "initial_unit"],

  computed: {
    ...mapGetters({
      user: "user",
      license: "license",
      whiteLabel: "whiteLabel",
    }),
  },
};
</script>

<style lang="scss" scoped></style>
